export var Type;
(function (Type) {
    Type["Number"] = "Number";
    Type["String"] = "String";
    Type["Boolean"] = "Boolean";
    Type["Object"] = "Object";
    Type["Array"] = "Array";
    Type["Function"] = "Function";
})(Type || (Type = {}));
export var HttpStatusType;
(function (HttpStatusType) {
    HttpStatusType[HttpStatusType["Continue"] = 100] = "Continue";
    HttpStatusType[HttpStatusType["SwitchingProtocol"] = 101] = "SwitchingProtocol";
    HttpStatusType[HttpStatusType["Processing"] = 102] = "Processing";
    HttpStatusType[HttpStatusType["OK"] = 200] = "OK";
    HttpStatusType[HttpStatusType["Created"] = 201] = "Created";
    HttpStatusType[HttpStatusType["Accepted"] = 202] = "Accepted";
    HttpStatusType[HttpStatusType["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HttpStatusType[HttpStatusType["NoContent"] = 204] = "NoContent";
    HttpStatusType[HttpStatusType["ResetContent"] = 205] = "ResetContent";
    HttpStatusType[HttpStatusType["PartialContent"] = 206] = "PartialContent";
    HttpStatusType[HttpStatusType["MultipleChoice"] = 300] = "MultipleChoice";
    HttpStatusType[HttpStatusType["MovedPermanently"] = 301] = "MovedPermanently";
    HttpStatusType[HttpStatusType["Found"] = 302] = "Found";
    HttpStatusType[HttpStatusType["SeeOther"] = 303] = "SeeOther";
    HttpStatusType[HttpStatusType["NotModified"] = 304] = "NotModified";
    HttpStatusType[HttpStatusType["BadRequest"] = 400] = "BadRequest";
    HttpStatusType[HttpStatusType["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusType[HttpStatusType["Forbidden"] = 403] = "Forbidden";
    HttpStatusType[HttpStatusType["NotFound"] = 404] = "NotFound";
    HttpStatusType[HttpStatusType["InternalServerError"] = 500] = "InternalServerError";
})(HttpStatusType || (HttpStatusType = {}));
export var ContentType;
(function (ContentType) {
    ContentType[ContentType["Image"] = 1] = "Image";
    ContentType[ContentType["Word"] = 2] = "Word";
    ContentType[ContentType["Excel"] = 3] = "Excel";
    ContentType[ContentType["Pdf"] = 4] = "Pdf";
    ContentType[ContentType["Video"] = 5] = "Video";
    ContentType[ContentType["Message"] = 6] = "Message";
    ContentType[ContentType["Email"] = 7] = "Email";
    ContentType[ContentType["Ppt"] = 8] = "Ppt";
    ContentType[ContentType["Audio"] = 9] = "Audio";
    ContentType[ContentType["Unknow"] = 10] = "Unknow";
})(ContentType || (ContentType = {}));
export var UserBehaviorType;
(function (UserBehaviorType) {
    UserBehaviorType[UserBehaviorType["PM"] = 1] = "PM";
    UserBehaviorType[UserBehaviorType["CLIENT"] = 2] = "CLIENT";
    UserBehaviorType[UserBehaviorType["AFFILIATE"] = 3] = "AFFILIATE";
})(UserBehaviorType || (UserBehaviorType = {}));
export var WOStatus;
(function (WOStatus) {
    WOStatus[WOStatus["PendingSchedule"] = 0] = "PendingSchedule";
    WOStatus[WOStatus["PendingDispatch"] = 1] = "PendingDispatch";
    WOStatus[WOStatus["PendingVendorAcceptance"] = 2] = "PendingVendorAcceptance";
    WOStatus[WOStatus["Scheduled"] = 3] = "Scheduled";
    WOStatus[WOStatus["OnSite"] = 4] = "OnSite";
    WOStatus[WOStatus["PendingVendorQuote"] = 5] = "PendingVendorQuote";
    WOStatus[WOStatus["VendorQuoteSubmitted"] = 6] = "VendorQuoteSubmitted";
    WOStatus[WOStatus["PendingApproval"] = 7] = "PendingApproval";
    WOStatus[WOStatus["QuoteRejected"] = 8] = "QuoteRejected";
    WOStatus[WOStatus["QuoteApproved"] = 9] = "QuoteApproved";
    WOStatus[WOStatus["ReturnTripNeeded"] = 10] = "ReturnTripNeeded";
    WOStatus[WOStatus["WorkCompletePendingVendorInvoice"] = 11] = "WorkCompletePendingVendorInvoice";
    WOStatus[WOStatus["VendorInvoiceReceived"] = 12] = "VendorInvoiceReceived";
    WOStatus[WOStatus["PendingInvoiceApproval"] = 13] = "PendingInvoiceApproval";
    WOStatus[WOStatus["VendorInvoiceRejected"] = 14] = "VendorInvoiceRejected";
    WOStatus[WOStatus["CompletedandInvoiced"] = 15] = "CompletedandInvoiced";
    WOStatus[WOStatus["VendorPaid"] = 16] = "VendorPaid";
    WOStatus[WOStatus["Closed"] = 17] = "Closed";
    WOStatus[WOStatus["ResolvedWithoutInvoice"] = 18] = "ResolvedWithoutInvoice";
    WOStatus[WOStatus["ResolvedWithoutDispatch"] = 19] = "ResolvedWithoutDispatch";
    WOStatus[WOStatus["Cancelled"] = 20] = "Cancelled";
    WOStatus[WOStatus["WorkOrderAvoidance"] = 21] = "WorkOrderAvoidance";
    WOStatus[WOStatus["PendingSelfHelpApproval"] = 22] = "PendingSelfHelpApproval";
    WOStatus[WOStatus["SelfHelpApproved"] = 23] = "SelfHelpApproved";
    WOStatus[WOStatus["Deferred"] = 24] = "Deferred";
    WOStatus[WOStatus["LandlordResolved"] = 25] = "LandlordResolved";
    WOStatus[WOStatus["VendorQuoteRejected"] = 26] = "VendorQuoteRejected";
    WOStatus[WOStatus["SelfHelpRejected"] = 27] = "SelfHelpRejected";
    WOStatus[WOStatus["BilledInProgress"] = 28] = "BilledInProgress";
    WOStatus[WOStatus["Billed"] = 29] = "Billed";
    WOStatus[WOStatus["Missed"] = 30] = "Missed";
    WOStatus[WOStatus["Rescheduled"] = 31] = "Rescheduled";
    WOStatus[WOStatus["Completed"] = 32] = "Completed";
    WOStatus[WOStatus["PaytoAffiliate"] = 33] = "PaytoAffiliate";
    WOStatus[WOStatus["Expired"] = 34] = "Expired";
    WOStatus[WOStatus["Void"] = 35] = "Void";
    WOStatus[WOStatus["LogRefusal"] = 36] = "LogRefusal";
    WOStatus[WOStatus["ServicePool"] = 37] = "ServicePool";
    WOStatus[WOStatus["PendingDispatchRFI"] = 38] = "PendingDispatchRFI";
})(WOStatus || (WOStatus = {}));
export var PredefinedClient;
(function (PredefinedClient) {
    PredefinedClient[PredefinedClient["CAH"] = 26] = "CAH";
    PredefinedClient[PredefinedClient["WPH"] = 26] = "WPH";
    PredefinedClient[PredefinedClient["HPA"] = 69] = "HPA";
    PredefinedClient[PredefinedClient["RentersWarehouse"] = 1085] = "RentersWarehouse";
    PredefinedClient[PredefinedClient["Tricon"] = 1086] = "Tricon";
    PredefinedClient[PredefinedClient["GPS"] = 1103] = "GPS";
    PredefinedClient[PredefinedClient["IH"] = 1200] = "IH";
    PredefinedClient[PredefinedClient["Nestidd"] = 1236] = "Nestidd";
    PredefinedClient[PredefinedClient["NHR"] = 1223] = "NHR";
    PredefinedClient[PredefinedClient["SA"] = 1222] = "SA";
    PredefinedClient[PredefinedClient["DAR"] = 1354] = "DAR";
    PredefinedClient[PredefinedClient["ARK"] = 1522] = "ARK";
    PredefinedClient[PredefinedClient["Rentredi"] = 1535] = "Rentredi";
})(PredefinedClient || (PredefinedClient = {}));
export var PredefinedClientCode;
(function (PredefinedClientCode) {
    PredefinedClientCode["BHI"] = "bhi";
})(PredefinedClientCode || (PredefinedClientCode = {}));
export var PredefinedWoType;
(function (PredefinedWoType) {
    PredefinedWoType[PredefinedWoType["StopFoodOrder"] = 22] = "StopFoodOrder";
    PredefinedWoType[PredefinedWoType["WorkOrder"] = 23] = "WorkOrder";
    PredefinedWoType[PredefinedWoType["OtherWO"] = 53] = "OtherWO";
    PredefinedWoType[PredefinedWoType["InHouseTechnician"] = 30] = "InHouseTechnician";
    PredefinedWoType[PredefinedWoType["ProCare"] = 70] = "ProCare";
    PredefinedWoType[PredefinedWoType["Recall"] = 16] = "Recall";
    PredefinedWoType[PredefinedWoType["ResidentResponsibility"] = 29] = "ResidentResponsibility";
})(PredefinedWoType || (PredefinedWoType = {}));
export var RatingState;
(function (RatingState) {
    RatingState[RatingState["Detail"] = 1] = "Detail";
    RatingState[RatingState["Success"] = 2] = "Success";
    RatingState[RatingState["Complete"] = 3] = "Complete";
    RatingState[RatingState["Fail"] = 4] = "Fail";
})(RatingState || (RatingState = {}));
export var LinkObjectType;
(function (LinkObjectType) {
    LinkObjectType[LinkObjectType["RecurrentWo"] = 1] = "RecurrentWo";
    LinkObjectType[LinkObjectType["ReactiveWo"] = 2] = "ReactiveWo";
    LinkObjectType[LinkObjectType["Call"] = 3] = "Call";
})(LinkObjectType || (LinkObjectType = {}));
export var WorkCompletedStatus;
(function (WorkCompletedStatus) {
    WorkCompletedStatus[WorkCompletedStatus["Yes"] = 1] = "Yes";
    WorkCompletedStatus[WorkCompletedStatus["No"] = 2] = "No";
    WorkCompletedStatus[WorkCompletedStatus["FurtherConfirm"] = 3] = "FurtherConfirm";
    WorkCompletedStatus[WorkCompletedStatus["ReadyforBilling"] = 4] = "ReadyforBilling";
})(WorkCompletedStatus || (WorkCompletedStatus = {}));
export var ProCareSupportBundleType;
(function (ProCareSupportBundleType) {
    ProCareSupportBundleType[ProCareSupportBundleType["Unsupported"] = 1] = "Unsupported";
    ProCareSupportBundleType[ProCareSupportBundleType["PullIn"] = 2] = "PullIn";
    ProCareSupportBundleType[ProCareSupportBundleType["PushOut"] = 3] = "PushOut";
    ProCareSupportBundleType[ProCareSupportBundleType["PullInOrPushOut"] = 4] = "PullInOrPushOut";
})(ProCareSupportBundleType || (ProCareSupportBundleType = {}));
export var BundleDataDirection;
(function (BundleDataDirection) {
    BundleDataDirection[BundleDataDirection["Normal"] = 1] = "Normal";
    BundleDataDirection[BundleDataDirection["Pull"] = 2] = "Pull";
    BundleDataDirection[BundleDataDirection["Push"] = 3] = "Push";
})(BundleDataDirection || (BundleDataDirection = {}));
export var PredefinePriority;
(function (PredefinePriority) {
    PredefinePriority[PredefinePriority["Response2H"] = 1] = "Response2H";
    PredefinePriority[PredefinePriority["Response4H"] = 2] = "Response4H";
    PredefinePriority[PredefinePriority["Response24H"] = 3] = "Response24H";
    PredefinePriority[PredefinePriority["Response48H"] = 4] = "Response48H";
    PredefinePriority[PredefinePriority["Response7D"] = 5] = "Response7D";
    PredefinePriority[PredefinePriority["Response14D"] = 6] = "Response14D";
    PredefinePriority[PredefinePriority["NextAvailableService"] = 7] = "NextAvailableService";
    PredefinePriority[PredefinePriority["RoutineExpeditedService"] = 8] = "RoutineExpeditedService";
    PredefinePriority[PredefinePriority["RoutineStandardService"] = 9] = "RoutineStandardService";
    PredefinePriority[PredefinePriority["Emergency"] = 10] = "Emergency";
    PredefinePriority[PredefinePriority["Expedited"] = 11] = "Expedited";
    PredefinePriority[PredefinePriority["TuneUp"] = 12] = "TuneUp";
    PredefinePriority[PredefinePriority["ResidentResponsibility"] = 13] = "ResidentResponsibility";
    PredefinePriority[PredefinePriority["Critical"] = 20] = "Critical";
    PredefinePriority[PredefinePriority["FeelsLike"] = 30000] = "FeelsLike"; // Virtual  FeelsLikePriorityId
})(PredefinePriority || (PredefinePriority = {}));
export var PredefinedServiceCategory;
(function (PredefinedServiceCategory) {
    PredefinedServiceCategory[PredefinedServiceCategory["AirConditioningHeating"] = 1] = "AirConditioningHeating";
    PredefinedServiceCategory[PredefinedServiceCategory["InternalCAH"] = 96] = "InternalCAH";
    PredefinedServiceCategory[PredefinedServiceCategory["ProCare"] = 1210] = "ProCare";
})(PredefinedServiceCategory || (PredefinedServiceCategory = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["Radio"] = 1] = "Radio";
    QuestionType[QuestionType["Input"] = 2] = "Input";
    QuestionType[QuestionType["TextArea"] = 3] = "TextArea";
    QuestionType[QuestionType["Select"] = 4] = "Select";
    QuestionType[QuestionType["LimitSelect"] = 6] = "LimitSelect";
    QuestionType[QuestionType["Label"] = 5] = "Label";
    QuestionType[QuestionType["CheckBox"] = 7] = "CheckBox";
})(QuestionType || (QuestionType = {}));
export var PredefinedProcareProjectWOType;
(function (PredefinedProcareProjectWOType) {
    PredefinedProcareProjectWOType[PredefinedProcareProjectWOType["ServiceCodeId"] = 8924] = "ServiceCodeId";
    PredefinedProcareProjectWOType[PredefinedProcareProjectWOType["ServiceTypeId"] = 1337] = "ServiceTypeId";
    PredefinedProcareProjectWOType[PredefinedProcareProjectWOType["ServiceCategoryId"] = 96] = "ServiceCategoryId";
})(PredefinedProcareProjectWOType || (PredefinedProcareProjectWOType = {}));
export var PredefinedProcareProjectWOTypeRename;
(function (PredefinedProcareProjectWOTypeRename) {
    PredefinedProcareProjectWOTypeRename[PredefinedProcareProjectWOTypeRename["ServiceCodeId"] = 11300] = "ServiceCodeId";
    PredefinedProcareProjectWOTypeRename[PredefinedProcareProjectWOTypeRename["ServiceTypeId"] = 2200] = "ServiceTypeId";
    PredefinedProcareProjectWOTypeRename[PredefinedProcareProjectWOTypeRename["ServiceCategoryId"] = 1210] = "ServiceCategoryId";
})(PredefinedProcareProjectWOTypeRename || (PredefinedProcareProjectWOTypeRename = {}));
export var FileType;
(function (FileType) {
    FileType[FileType["Image"] = 0] = "Image";
    FileType[FileType["Unknown"] = 1] = "Unknown";
    FileType[FileType["Word"] = 2] = "Word";
    FileType[FileType["Excel"] = 3] = "Excel";
    FileType[FileType["Pdf"] = 4] = "Pdf";
    FileType[FileType["Video"] = 5] = "Video";
    FileType[FileType["Msg"] = 6] = "Msg";
    FileType[FileType["Mp3"] = 7] = "Mp3";
})(FileType || (FileType = {}));
export var PredefinedClientName;
(function (PredefinedClientName) {
    PredefinedClientName[PredefinedClientName["Invitation Homes"] = 1200] = "Invitation Homes";
    PredefinedClientName[PredefinedClientName["Waypoint Homes"] = 26] = "Waypoint Homes";
    PredefinedClientName[PredefinedClientName["Pathlight Property Management"] = 69] = "Pathlight Property Management";
    PredefinedClientName[PredefinedClientName["Renters Warehouse"] = 1085] = "Renters Warehouse";
    PredefinedClientName[PredefinedClientName["Tricon"] = 1086] = "Tricon";
    PredefinedClientName[PredefinedClientName["GOAL Properties"] = 1103] = "GOAL Properties";
    PredefinedClientName[PredefinedClientName["Nestidd"] = 1236] = "Nestidd";
    PredefinedClientName[PredefinedClientName["National Home Rentals"] = 1223] = "National Home Rentals";
    PredefinedClientName[PredefinedClientName["Second Avenue"] = 1222] = "Second Avenue";
    PredefinedClientName[PredefinedClientName["ARK Homes For Rent"] = 1522] = "ARK Homes For Rent";
})(PredefinedClientName || (PredefinedClientName = {}));
export var SessionKey;
(function (SessionKey) {
    SessionKey["ScheduleDate"] = "ScheduleDate";
    SessionKey["Attachments"] = "Attachments";
    SessionKey["CommonQuestion"] = "CommonQuestion";
    SessionKey["ServiceCodeQuestion"] = "ServiceCodeQuestion";
    SessionKey["ServiceIssue"] = "serviceIssue";
    SessionKey["AccessInformation"] = "AccessInformation";
    SessionKey["ReactiveWo"] = "ReactiveWo";
    SessionKey["AutoScheduleModel"] = "AutoScheduleModel";
    SessionKey["SliceScheduleListAllSumZero"] = "SliceScheduleListAllSumZero";
    SessionKey["SelectedSchedule"] = "SelectedSchedule";
    SessionKey["AutoScheduleModelWithLastVersion"] = "AutoScheduleModelWithLastVersion";
    SessionKey["ScheduleListAllNoCanSelectWithLastVersion"] = "ScheduleListAllNoCanSelectWithLastVersion";
    SessionKey["SelectedScheduleWithLastVersion"] = "SelectedScheduleWithLastVersion";
    SessionKey["IsSubmitWo"] = "isSubmitWo";
})(SessionKey || (SessionKey = {}));
export var AutoScheduleControl;
(function (AutoScheduleControl) {
    AutoScheduleControl["NoAvailable"] = "NoAvailable";
    AutoScheduleControl["Disable"] = "Disable";
    AutoScheduleControl[AutoScheduleControl["Tricon"] = 1086] = "Tricon";
})(AutoScheduleControl || (AutoScheduleControl = {}));
export var LibraryTypeId;
(function (LibraryTypeId) {
    LibraryTypeId[LibraryTypeId["Video"] = 2] = "Video";
    LibraryTypeId[LibraryTypeId["Guide"] = 1] = "Guide";
})(LibraryTypeId || (LibraryTypeId = {}));
export var ClientUserTrackingCode;
(function (ClientUserTrackingCode) {
    ClientUserTrackingCode["ReactiveWOSchedule"] = "WCLRAW018361507";
    ClientUserTrackingCode["ReactiveWOReschedule"] = "WCLRAW102361507";
    ClientUserTrackingCode["ScheduleCalendarReschedule"] = "WCL026102361507";
    ClientUserTrackingCode["ProCareSchedule"] = "WCL027105361507";
    ClientUserTrackingCode["RspProCareSchedule"] = "WCL023106249509";
    ClientUserTrackingCode["RspProCareReschedule"] = "WCL023106241509";
})(ClientUserTrackingCode || (ClientUserTrackingCode = {}));
export var SelectScheduleTimeType;
(function (SelectScheduleTimeType) {
    SelectScheduleTimeType[SelectScheduleTimeType["NotSelectTime"] = 0] = "NotSelectTime";
    SelectScheduleTimeType[SelectScheduleTimeType["SelectRecommendedTime"] = 1] = "SelectRecommendedTime";
    SelectScheduleTimeType[SelectScheduleTimeType["SelectCommonTime"] = 2] = "SelectCommonTime";
})(SelectScheduleTimeType || (SelectScheduleTimeType = {}));
export var EScheduleSubTaskResult;
(function (EScheduleSubTaskResult) {
    EScheduleSubTaskResult[EScheduleSubTaskResult["Default"] = 0] = "Default";
    EScheduleSubTaskResult[EScheduleSubTaskResult["CannotBeAddedToThisInterval"] = 1] = "CannotBeAddedToThisInterval";
    EScheduleSubTaskResult[EScheduleSubTaskResult["MoreThan9Hours30Minutes"] = 2] = "MoreThan9Hours30Minutes";
})(EScheduleSubTaskResult || (EScheduleSubTaskResult = {}));
export var EScheduleServiceType;
(function (EScheduleServiceType) {
    EScheduleServiceType[EScheduleServiceType["PullIn"] = 1] = "PullIn";
    EScheduleServiceType[EScheduleServiceType["PushOut"] = 2] = "PushOut";
})(EScheduleServiceType || (EScheduleServiceType = {}));
export var EmailScheduleType;
(function (EmailScheduleType) {
    EmailScheduleType[EmailScheduleType["ScheduleSuccuess"] = 1] = "ScheduleSuccuess";
    EmailScheduleType[EmailScheduleType["ScheduleFailedReasonUnkown"] = 2] = "ScheduleFailedReasonUnkown";
    EmailScheduleType[EmailScheduleType["VisitCheckFailed"] = 3] = "VisitCheckFailed";
    EmailScheduleType[EmailScheduleType["TechnicianNotAvailible"] = 4] = "TechnicianNotAvailible";
})(EmailScheduleType || (EmailScheduleType = {}));
export var PrimaryPhoneAndTextMessageApprovedStatus;
(function (PrimaryPhoneAndTextMessageApprovedStatus) {
    PrimaryPhoneAndTextMessageApprovedStatus[PrimaryPhoneAndTextMessageApprovedStatus["Failed"] = 0] = "Failed";
    PrimaryPhoneAndTextMessageApprovedStatus[PrimaryPhoneAndTextMessageApprovedStatus["Success"] = 1] = "Success";
})(PrimaryPhoneAndTextMessageApprovedStatus || (PrimaryPhoneAndTextMessageApprovedStatus = {}));
export var AmplitudeProjectName;
(function (AmplitudeProjectName) {
    AmplitudeProjectName["Default"] = "Default";
    AmplitudeProjectName["ARK_RSP_OTP"] = "ARK-RSP-OTP";
    AmplitudeProjectName["NewLogin"] = "NewLogin";
})(AmplitudeProjectName || (AmplitudeProjectName = {}));
export var AmplitudeEventName;
(function (AmplitudeEventName) {
    AmplitudeEventName["Dashboard_MenuIcon"] = "Dashboard_MenuIcon";
    AmplitudeEventName["Dashboard_ServiceRequest"] = "Dashboard_ServiceRequest";
    AmplitudeEventName["Upcoming_Item"] = "Upcoming_Item";
    AmplitudeEventName["ServiceRequest_Item"] = "ServiceRequest_Item";
    AmplitudeEventName["Communication_EntryInfo_Save"] = "Communication_EntryInfo_Save";
    AmplitudeEventName["Communication_CameraIcon"] = "Communication_CameraIcon";
    AmplitudeEventName["Communication_Send"] = "Communication_Send";
    AmplitudeEventName["Panel_Home"] = "Panel_Home";
    AmplitudeEventName["Panel_ScheduledService"] = "Panel_ScheduledService";
    AmplitudeEventName["Panel_ServiceHistory"] = "Panel_ServiceHistory";
    AmplitudeEventName["Panel_Messages"] = "Panel_Messages";
    AmplitudeEventName["Panel_MaintenanceHowTo"] = "Panel_MaintenanceHowTo";
    AmplitudeEventName["Panel_PortalHowTo_Videos"] = "Panel_PortalHowTo_Videos";
    AmplitudeEventName["Panel_PortalHowTo_Guides"] = "Panel_PortalHowTo_Guides";
    AmplitudeEventName["Panel_ContactUs"] = "Panel_ContactUs";
    AmplitudeEventName["Panel_Settings"] = "Panel_Settings";
    AmplitudeEventName["Panel_SignOut"] = "Panel_SignOut";
    AmplitudeEventName["Panel_ServiceRating"] = "Panel_ServiceRating";
    AmplitudeEventName["Panel_TrainingResources_Videos"] = "Panel_TrainingResources_Videos";
    AmplitudeEventName["Panel_TrainingResources_Guides"] = "Panel_TrainingResources_Guides";
    AmplitudeEventName["Login_Page"] = "Login_Page";
    AmplitudeEventName["Login_Failed"] = "Login_Failed";
    AmplitudeEventName["Login_Success"] = "Login_Success";
    AmplitudeEventName["Login_ForgetPassWord"] = "Login_ForgetPassWord";
    AmplitudeEventName["SingUp_Page"] = "SingUp_Page";
    AmplitudeEventName["SingUp_SendEmail"] = "SingUp_SendEmail";
    AmplitudeEventName["SingUp_CreateUser"] = "SingUp_CreateUser";
    AmplitudeEventName["SingUp_CreateUser_SuccessToDashboard"] = "SingUp_CreateUser_SuccessToDashboard";
    AmplitudeEventName["New_login_visited"] = "New_login_visited";
    AmplitudeEventName["New_forgot_password_success"] = "New_forgot_password_success";
    AmplitudeEventName["New_forgot_password_error"] = "New_forgot_password_error";
    AmplitudeEventName["New_login_success"] = "New_login_success";
    AmplitudeEventName["New_logout_click"] = "New_logout_click";
    AmplitudeEventName["One_time_password_success"] = "One_time_password_success";
    AmplitudeEventName["One_time_password_submit_error"] = "One_time_password_submit_error";
    AmplitudeEventName["One_time_password_code_error"] = "One_time_password_code_error";
    AmplitudeEventName["Continue_Google_success"] = "Continue_Google_success";
    AmplitudeEventName["Continue_Google_error"] = "Continue_Google_error";
    AmplitudeEventName["Continue_Apple_success"] = "Continue_Apple_success";
    AmplitudeEventName["Continue_Apple_error"] = "Continue_Apple_error";
    AmplitudeEventName["Procare_Page"] = "Procare_Page";
    AmplitudeEventName["Procare_AddFridgeListItem"] = "Procare_AddFridgeListItem";
    AmplitudeEventName["Procare_AddFridgeListItem_Proceed"] = "Procare_AddFridgeListItem_Proceed";
    AmplitudeEventName["Procare_AddFridgeListItem_Cancel"] = "Procare_AddFridgeListItem_Cancel";
    AmplitudeEventName["Procare_AddFridgeListItem_Submit"] = "Procare_AddFridgeListItem_Submit";
    AmplitudeEventName["Procare_Schedule"] = "Procare_Schedule";
    AmplitudeEventName["Availability"] = "Availability";
    AmplitudeEventName["Availability_Yes"] = "Availability_Yes";
    AmplitudeEventName["Availability_Yes_First"] = "Availability_Yes_First";
    AmplitudeEventName["Availability_Yes_Second"] = "Availability_Yes_Second";
    AmplitudeEventName["Availability_Yes_Third"] = "Availability_Yes_Third";
    AmplitudeEventName["Availability_No"] = "Availability_No";
    AmplitudeEventName["Wo_Upcoming"] = "Wo_Upcoming";
    AmplitudeEventName["Wo_ServiceRequest"] = "Wo_ServiceRequest";
    AmplitudeEventName["Wo_Upload_Image"] = "Wo_Upload_Image";
    AmplitudeEventName["ResetPassword_SendEmail"] = "ResetPassword_SendEmail";
    AmplitudeEventName["ResetPasswordByEmail"] = "ResetPasswordByEmail";
    AmplitudeEventName["ProposedTimeForWO"] = "ProposedTimeForWO";
    AmplitudeEventName["ProposedTimeSubmitted"] = "ProposedTimeSubmitted";
    AmplitudeEventName["OldRsp_RequestRepair"] = "OldRsp_RequestRepair";
    AmplitudeEventName["OldRsp_Step1to2"] = "OldRsp_Step1to2";
    AmplitudeEventName["OldRSP_Step2to3"] = "OldRSP_Step2to3";
    AmplitudeEventName["OldRSP_Step3to4"] = "OldRSP_Step3to4";
    AmplitudeEventName["OldRSP_Step4to5"] = "OldRSP_Step4to5";
    AmplitudeEventName["OldRSP_Create_WO_Succeeded"] = "OldRSP_Create_WO_Succeeded";
    AmplitudeEventName["OldRSP_Create_WO_Failed"] = "OldRSP_Create_WO_Failed";
    AmplitudeEventName["NewRSP_CantFindIssue"] = "NewRSP_CantFindIssue";
    AmplitudeEventName["NewRSP_RequestRepair"] = "NewRSP_RequestRepair";
    AmplitudeEventName["NewRSP_Step1to2"] = "NewRSP_Step1to2";
    AmplitudeEventName["NewRSP_Step2to3"] = "NewRSP_Step2to3";
    AmplitudeEventName["NewRSP_Step3to4"] = "NewRSP_Step3to4";
    AmplitudeEventName["NewRSP_Step4to5"] = "NewRSP_Step4to5";
    AmplitudeEventName["NewRSP_Step5to6"] = "NewRSP_Step5to6";
    AmplitudeEventName["NewRSP_Create_WO_Failed"] = "NewRSP_Create_WO_Failed";
    AmplitudeEventName["NewRSP_Back"] = "NewRSP_Back";
    AmplitudeEventName["NewRSP_Edit"] = "NewRSP_Edit";
    AmplitudeEventName["NewRSP_WOTimeLine"] = "NewRSP_WOTimeLine";
    AmplitudeEventName["NewRSP_Browser_Back"] = "NewRSP_Browser_Back";
    AmplitudeEventName["NewRsp_IHClickAppStore"] = "NewRsp_IHClickAppStore";
    AmplitudeEventName["NewRsp_NoIHClickAppStore"] = "NewRsp_NoIHClickAppStore";
    AmplitudeEventName["NewRsp_IHClickGooglePlay"] = "NewRsp_IHClickGooglePlay";
    AmplitudeEventName["NewRsp_NoIHClickGooglePlay"] = "NewRsp_NoIHClickGooglePlay";
    AmplitudeEventName["RSPDuplicate_RelatedIssue"] = "RSPDuplicate_RelatedIssue";
    AmplitudeEventName["RSPDuplicate_EditDescription"] = "RSPDuplicate_EditDescription";
    AmplitudeEventName["RSPDuplicate_EditAttachment"] = "RSPDuplicate_EditAttachment";
    AmplitudeEventName["RSPDuplicate_DifferentIssue"] = "RSPDuplicate_DifferentIssue";
    AmplitudeEventName["RSPDuplicateWOs_Count"] = "RSPDuplicateWOs_Count";
    AmplitudeEventName["WOCreation_Disclaimer_RSP"] = "WOCreation_Disclaimer_RSP";
    AmplitudeEventName["WOCreation_Disclaimer_proceed_RSP"] = "WOCreation_Disclaimer_proceed_RSP";
    AmplitudeEventName["WOCreation_Disclaimer_cancel_RSP"] = "WOCreation_Disclaimer_cancel_RSP";
    AmplitudeEventName["WOCreation_ResidentResponsibility_RSP"] = "WOCreation_ResidentResponsibility_RSP";
    AmplitudeEventName["WOCreation_ResidentResponsibility_proceed_RSP"] = "WOCreation_ResidentResponsibility_proceed_RSP";
    AmplitudeEventName["WOCreation_ResidentResponsibility_cancel_RSP"] = "WOCreation_ResidentResponsibility_cancel_RSP";
    AmplitudeEventName["CLICK_MAGIC_LINK_INTO_RSP"] = "CLICK_MAGIC_LINK_INTO_RSP";
    AmplitudeEventName["RESIDENT_USER_SUBMIT"] = "RESIDENT_USER_SUBMIT";
    AmplitudeEventName["RESIDENT_USER_SAY_NO_TIMES"] = "RESIDENT_USER_SAY_NO_TIMES";
    AmplitudeEventName["RESIDENT_USER_FORWARD_TO_ANOTHER_RESIDENT"] = "RESIDENT_USER_FORWARD_TO_ANOTHER_RESIDENT";
    AmplitudeEventName["RESIDENT_USER_ANOTHER_RESIDENT_SUBMITTED"] = "RESIDENT_USER_ANOTHER_RESIDENT_SUBMITTED";
    AmplitudeEventName["RESIDENT_USER_NONE_TIMES_WORK_REASON_SUBMITTED"] = "RESIDENT_USER_NONE_TIMES_WORK_REASON_SUBMITTED";
    AmplitudeEventName["CLICK_MAGIC_LINK_INTO_RSP_RTN"] = "CLICK_MAGIC_LINK_INTO_RSP_RTN";
    AmplitudeEventName["RESIDENT_USER_SUBMIT_RTN"] = "RESIDENT_USER_SUBMIT_RTN";
    AmplitudeEventName["RESIDENT_USER_SAY_NO_TIMES_RTN"] = "RESIDENT_USER_SAY_NO_TIMES_RTN";
    AmplitudeEventName["RESIDENT_USER_FORWARD_TO_ANOTHER_RESIDENT_RTN"] = "RESIDENT_USER_FORWARD_TO_ANOTHER_RESIDENT_RTN";
    AmplitudeEventName["RESIDENT_USER_ANOTHER_RESIDENT_SUBMITTED_RTN"] = "RESIDENT_USER_ANOTHER_RESIDENT_SUBMITTED_RTN";
    AmplitudeEventName["RESIDENT_USER_NONE_TIMES_WORK_REASON_SUBMITTED_RTN"] = "RESIDENT_USER_NONE_TIMES_WORK_REASON_SUBMITTED_RTN";
    AmplitudeEventName["Homepage_AppBanner_display"] = "Homepage_AppBanner_display";
    AmplitudeEventName["Homepage_AppBanner_download"] = "Homepage_AppBanner_download";
    AmplitudeEventName["Homepage_AppBanner_cross"] = "Homepage_AppBanner_cross";
    AmplitudeEventName["OTP_Click_Entry"] = "OTP_Click_Entry";
    AmplitudeEventName["OTP_Click_PhoneContinue"] = "OTP_Click_PhoneContinue";
    AmplitudeEventName["OTP_Transition_PhoneContinue_To_Verify"] = "OTP_Transition_PhoneContinue_To_Verify";
    AmplitudeEventName["OTP_Click_Verify"] = "OTP_Click_Verify";
    AmplitudeEventName["OTP_Transition_Verify_Redirect_To_RSP"] = "OTP_Transition_Verify_Redirect_To_RSP";
    AmplitudeEventName["OTP_Click_NewCode"] = "OTP_Click_NewCode";
    AmplitudeEventName["OTP_Transition_PhoneContinue_To_Address"] = "OTP_Transition_PhoneContinue_To_Address";
    AmplitudeEventName["OTP_Click_AddressContinue"] = "OTP_Click_AddressContinue";
    AmplitudeEventName["OTP_Click_SelectResident"] = "OTP_Click_SelectResident";
    AmplitudeEventName["OTP_Click_SelectResidentContinue"] = "OTP_Click_SelectResidentContinue";
    AmplitudeEventName["OTP_Transition_SelectResidentContinue_To_Verify"] = "OTP_Transition_SelectResidentContinue_To_Verify";
    AmplitudeEventName["OTP_Click_ContactUs"] = "OTP_Click_ContactUs";
    AmplitudeEventName["OTP_Click_CantFindMYPhone"] = "OTP_Click_CantFindMYPhone";
    AmplitudeEventName["OTP_Click_Back"] = "OTP_Click_Back";
    AmplitudeEventName["OTP_Click_Done"] = "OTP_Click_Done";
    AmplitudeEventName["Troubleshoot_Recommended_SVC_Close"] = "RequestMaintenance_UpdateSVC_close";
    AmplitudeEventName["Troubleshoot_Recommended_SVC_Go"] = "RequestMaintenance_UpdateSVC_gotit";
    AmplitudeEventName["Copilot_Maintenance_Request"] = "Copilot_Maintenance_Request";
    AmplitudeEventName["Copilot_Communication_Intent"] = "Copilot_Communication_Intent";
    AmplitudeEventName["Copilot_Communication_Success"] = "Copilot_Communication_Success";
    AmplitudeEventName["Copilot_Communication_Failed"] = "Copilot_Communication_Failed";
})(AmplitudeEventName || (AmplitudeEventName = {}));
export var EventLogReferenceType;
(function (EventLogReferenceType) {
    EventLogReferenceType[EventLogReferenceType["ReactiveWO"] = 0] = "ReactiveWO";
    EventLogReferenceType[EventLogReferenceType["RecurrentWO"] = 1] = "RecurrentWO";
    EventLogReferenceType[EventLogReferenceType["Call"] = 3] = "Call";
})(EventLogReferenceType || (EventLogReferenceType = {}));
export var ScheduleEntryType;
(function (ScheduleEntryType) {
    ScheduleEntryType[ScheduleEntryType["CreateWO"] = 1] = "CreateWO";
    ScheduleEntryType[ScheduleEntryType["ProcareSchedule"] = 2] = "ProcareSchedule";
    ScheduleEntryType[ScheduleEntryType["MessageSchedule"] = 3] = "MessageSchedule";
})(ScheduleEntryType || (ScheduleEntryType = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType[ScheduleType["ReactiveWO"] = 1] = "ReactiveWO";
    ScheduleType[ScheduleType["ProCare"] = 2] = "ProCare";
})(ScheduleType || (ScheduleType = {}));
export var StepType;
(function (StepType) {
    StepType[StepType["Problem"] = 1] = "Problem";
    StepType[StepType["Detail"] = 2] = "Detail";
    StepType[StepType["Question"] = 3] = "Question";
    StepType[StepType["Availability"] = 4] = "Availability";
    StepType[StepType["Review"] = 5] = "Review";
    StepType[StepType["Submitted"] = 6] = "Submitted";
    StepType[StepType["DuplicateOriginWOSubmitted"] = 7] = "DuplicateOriginWOSubmitted";
})(StepType || (StepType = {}));
export var ProblemLevel;
(function (ProblemLevel) {
    ProblemLevel[ProblemLevel["LevelOne"] = 1] = "LevelOne";
    ProblemLevel[ProblemLevel["LevelTwo"] = 2] = "LevelTwo";
    ProblemLevel[ProblemLevel["LevelThree"] = 3] = "LevelThree";
    ProblemLevel[ProblemLevel["ResidentResponsiBility"] = 4] = "ResidentResponsiBility";
    ProblemLevel[ProblemLevel["DuplicateCheck"] = 5] = "DuplicateCheck";
    ProblemLevel[ProblemLevel["DuplicateOriginWO"] = 6] = "DuplicateOriginWO";
    ProblemLevel[ProblemLevel["RecallCheck"] = 7] = "RecallCheck";
    ProblemLevel[ProblemLevel["RecallOriginWO"] = 8] = "RecallOriginWO";
    ProblemLevel[ProblemLevel["DifferentIssue"] = 9] = "DifferentIssue";
    ProblemLevel[ProblemLevel["HowToVideo"] = 10] = "HowToVideo";
})(ProblemLevel || (ProblemLevel = {}));
export var MobileDefinedClientType;
(function (MobileDefinedClientType) {
    MobileDefinedClientType[MobileDefinedClientType["IHResidential"] = 1] = "IHResidential";
    MobileDefinedClientType[MobileDefinedClientType["NonIHResidential"] = 2] = "NonIHResidential";
})(MobileDefinedClientType || (MobileDefinedClientType = {}));
export var TimeQuantum;
(function (TimeQuantum) {
    TimeQuantum["Allday"] = "All day";
    TimeQuantum["Morning"] = "Morning";
    TimeQuantum["Afternoon"] = "Afternoon";
    TimeQuantum["EarlyEvening"] = "Early evening";
    TimeQuantum["Evening"] = "Evening";
})(TimeQuantum || (TimeQuantum = {}));
export var SpecificTime;
(function (SpecificTime) {
    SpecificTime["Allday"] = "8:00 AM - 8:00 PM";
    SpecificTime["Morning"] = "8:00 AM - 1:00 PM";
    SpecificTime["Afternoon"] = "1:00 PM - 8:00 PM";
})(SpecificTime || (SpecificTime = {}));
export var ScrollListPage;
(function (ScrollListPage) {
    ScrollListPage[ScrollListPage["FirstPage"] = 1] = "FirstPage";
    ScrollListPage[ScrollListPage["SecondPage"] = 2] = "SecondPage";
})(ScrollListPage || (ScrollListPage = {}));
export var RecommendType;
(function (RecommendType) {
    RecommendType[RecommendType["recommendIn5Days"] = 1] = "recommendIn5Days";
    RecommendType[RecommendType["recommendAfter5Days"] = 2] = "recommendAfter5Days";
    RecommendType[RecommendType["noRecommend"] = 3] = "noRecommend";
})(RecommendType || (RecommendType = {}));
export var ProposedTimePageType;
(function (ProposedTimePageType) {
    ProposedTimePageType[ProposedTimePageType["NotSubmitted"] = 1] = "NotSubmitted";
    ProposedTimePageType[ProposedTimePageType["Forward"] = 2] = "Forward";
    ProposedTimePageType[ProposedTimePageType["NoneTimesWork"] = 3] = "NoneTimesWork";
})(ProposedTimePageType || (ProposedTimePageType = {}));
export var ResidentMagicLinkStatus;
(function (ResidentMagicLinkStatus) {
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["InvalidKey"] = 0] = "InvalidKey";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["TokenExpired"] = 1] = "TokenExpired";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["TokenExpiredCanReset"] = 2] = "TokenExpiredCanReset";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["UnableToSchedule"] = 3] = "UnableToSchedule";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["Schedule"] = 4] = "Schedule";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["Completed"] = 5] = "Completed";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["TimeApproaching"] = 6] = "TimeApproaching";
    ResidentMagicLinkStatus[ResidentMagicLinkStatus["NoTechnician"] = 7] = "NoTechnician";
})(ResidentMagicLinkStatus || (ResidentMagicLinkStatus = {}));
export var QuestionReferenceType;
(function (QuestionReferenceType) {
    QuestionReferenceType[QuestionReferenceType["CommonQuestion"] = 0] = "CommonQuestion";
    QuestionReferenceType[QuestionReferenceType["ServiceCodeQuestion"] = 1] = "ServiceCodeQuestion";
    QuestionReferenceType[QuestionReferenceType["CheckOutQuestion"] = 2] = "CheckOutQuestion";
    QuestionReferenceType[QuestionReferenceType["CommonCheckOutQuestion"] = 3] = "CommonCheckOutQuestion";
    QuestionReferenceType[QuestionReferenceType["LocationAsset"] = 5] = "LocationAsset";
    QuestionReferenceType[QuestionReferenceType["LocationAssetPart"] = 6] = "LocationAssetPart";
})(QuestionReferenceType || (QuestionReferenceType = {}));
export var PostMessageType;
(function (PostMessageType) {
    /** listen message Type */
    PostMessageType["CopilotPageInfo"] = "copilot_page_info";
    PostMessageType["CloseCopilotWindow"] = "close_copilot_window";
    PostMessageType["RspCommucationSendMsg"] = "rsp_commucation_send_msg";
    PostMessageType["ContentLoaded"] = "content_loaded";
    PostMessageType["UpdateDetail"] = "update_detail";
    /** post message Type */
    PostMessageType["OpenLeaveModal"] = "open_leave_modal";
    PostMessageType["JoinedCopilot"] = "joined_copilot";
    PostMessageType["WoCreate_submit"] = "WoCreate_submit";
    PostMessageType["Init_Page_Info"] = "Init_Page_Info";
})(PostMessageType || (PostMessageType = {}));
export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["Copilot_FixedButton"] = "Copilot_FixedButton";
})(LocalStorageKey || (LocalStorageKey = {}));
export var EntryChannelSubType;
(function (EntryChannelSubType) {
    EntryChannelSubType[EntryChannelSubType["RSP_Request_Repair"] = 3] = "RSP_Request_Repair";
    EntryChannelSubType[EntryChannelSubType["RSP_Communication"] = 7] = "RSP_Communication";
})(EntryChannelSubType || (EntryChannelSubType = {}));
export var OauthPlatform;
(function (OauthPlatform) {
    OauthPlatform["Google"] = "1";
    OauthPlatform["Apple"] = "2";
})(OauthPlatform || (OauthPlatform = {}));
export var OauthFlag;
(function (OauthFlag) {
    OauthFlag["Failed"] = "0";
    OauthFlag["Success"] = "1";
})(OauthFlag || (OauthFlag = {}));
export var SourceType;
(function (SourceType) {
    SourceType[SourceType["Rsp"] = 4] = "Rsp";
})(SourceType || (SourceType = {}));
export var SourceTypeName;
(function (SourceTypeName) {
    SourceTypeName["Rsp"] = "Rsp";
})(SourceTypeName || (SourceTypeName = {}));
export var MessageSenderType;
(function (MessageSenderType) {
    MessageSenderType["Maintenance"] = "101";
    MessageSenderType["Resident"] = "205";
    MessageSenderType["PropertyManager"] = "251";
})(MessageSenderType || (MessageSenderType = {}));
export var MessageSendTo;
(function (MessageSendTo) {
    MessageSendTo[MessageSendTo["Maintenance"] = 0] = "Maintenance";
    MessageSendTo[MessageSendTo["PropertyManager"] = 1] = "PropertyManager";
})(MessageSendTo || (MessageSendTo = {}));
